import { IPlannedPortfolio } from 'src/app/models/plannedPortfolios';
import { IPlannedPortfolioPayload } from '../../models/plannedPortfolios';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { BaseHttpService } from './base.http.service';
import { AppConfig } from 'src/app/app.config';
import { IEnvironmentConfig } from 'src/app/models/environmentConfig';

@Injectable()
export class PlannedPortfoliosService extends BaseHttpService {
    constructor(private http: HttpClient, private appConfig: AppConfig) {
        super();
    }

    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }

    public getPlannedPortfolio(payload: IPlannedPortfolioPayload): Observable<any> {
        const queryString = '?subscriptionIds=' + payload.subscriptionId;
        const url = `${this.envSettings.webApiUrl}modelportfolios/${payload.modelPortfolioId}/plannedportfolios/${queryString}`;
        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public getTemporaryPlannedPortfolio(payload: IPlannedPortfolio): Observable<any> {
        const modelPortfolioId = payload.modelPortfolioId;
        const url = `${this.envSettings.webApiUrl}modelportfolios/${modelPortfolioId}/plannedportfolios/temporary`;
        const body = JSON.stringify([payload]);
        return this.http.post(url, body, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public savePlannedPortfolio(plannedPortfolio: IPlannedPortfolio): Observable<any> {
        const modelPortfolioId: number = plannedPortfolio.modelPortfolioId;
        const subscriptionId: number = plannedPortfolio.subscriptionId;
        const jsonBody = JSON.stringify(plannedPortfolio);
        const url = `${this.envSettings.webApiUrl}/modelportfolios/${modelPortfolioId}/subscriptions/${subscriptionId}/plannedportfolio`;
        return this.http.post(url, jsonBody, {
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }
}